/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path utils
 * @description Date formatting for en and ar
 * @section 4.1.9.3
 */
export default function useDownload() {
  const download = (href: string, fileName?: string) => {
    const file_name = fileName || href.split("/").pop() || "filename";
    fetch(href, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file_name);
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return download;
}
